<mat-form-field>
  <label *ngIf="fieldLabel" for="{{ fieldId }}">
    {{ fieldLabel }}
    <span *ngIf="fieldOptLabel">{{ fieldOptLabel }}</span>
    <span *ngIf="isRequired" class="required">*</span>
  </label>
  <input
    id="{{ fieldId }}"
    matInput
    [matAutocomplete]="fieldAutoComplete"
    (keyup)="textTyped$.next($event.target.value)"
    [value]="displayedValue" 
    [disabled]="isDisabled"
    [placeholder]="placeHolderText" />
</mat-form-field>
<mat-autocomplete
  #fieldAutoComplete="matAutocomplete"
  [displayWith]="displayFn.bind(this)">
  <mat-option *ngIf="filteredOptions && filteredOptions.length === 0" disabled>
    {{ noEntriesFoundLabel }}
  </mat-option>
  <mat-option
    *ngFor="let filteredOption of filteredOptions;"
    matTooltip="{{ displayTooltip ? isAddressAutocomplete ? (filteredOption | ivAddressTooltipFn) : filteredOption[fieldKeys.label] : '' }}"
    [value]="filteredOption"
    (onSelectionChange)="optionSelected($event)">
    <span class="{{ fieldName }}-{{ filteredOption[fieldKeys.value] }}">{{ displayFn(filteredOption) }}</span>
  </mat-option>
</mat-autocomplete>